import { useState, useEffect, memo } from "react";
import { useDrag } from "../hooks/useDrag";

/**
 * Slider — memoized, isolated drag state.
 * Only this component re-renders during drag.
 * Parent is notified via onDrag (preview) and onCommit (final).
 *
 * Props: label, min, max, value, onCommit, onDrag, suffix, dampened
 */
const Slider = memo(function Slider({ label, min, max, value, onCommit, onDrag, suffix, dampened }) {
  const [localVal, setLocalVal] = useState(value);
  const { inputRef, handleInput: rawInput, handleCommit, syncFromProp } = useDrag({
    value, onDrag, onCommit, min, max, dampened
  });

  useEffect(() => {
    syncFromProp(value);
    setLocalVal(value);
  }, [value, syncFromProp]);

  const handleInput = (e) => {
    const v = rawInput(e);
    setLocalVal(v);
  };

  return (
    <div className="control-group" data-testid={`slider-${label.replace(/\s+/g, '-')}`}>
      <label>{label}</label>
      <div className="slider-row">
        <input
          ref={inputRef}
          type="range" min={min} max={max} value={localVal}
          onChange={handleInput}
          onPointerUp={handleCommit}
          onKeyUp={handleCommit}
        />
        <span>{localVal}{suffix || ''}</span>
      </div>
    </div>
  );
});

export default Slider;
